import React from "react";
import { Box, Typography } from "@mui/material";

const PrivacyPolicy = () => {
    return (
        <Box
            sx={{
                backgroundColor: "#fff",
                color: "#003C69",
                fontSize: "20px",
                lineHeight: 1.6,
                mt: 15,
                p: { xs: 3, md: 6 },
                px: { xs:5, md: 25},
            }}
        >
            {/* Page Title */}
            <Typography
                variant="h3"
                sx={{
                    fontWeight: "bold",
                    mb: 8,
                    textAlign: "center",
                    fontSize: { xs: "28px", md: "36px" },
                }}
            >
                Privacy Policy
            </Typography>

            <Typography sx={{ mb: 4, fontSize: "20px",  }}>
                The GCF is committed to respecting user data and information and is
                obliged to maintain the confidentiality and privacy of personal data as
                per relevant regulations. To this end, a privacy policy has been
                prepared to understand how personal data is collected, its purpose,
                methods of sharing, exchanging, and storing it, and the rights of Data
                subject. Using the GCF’s website constitutes user consent to the privacy
                policy as per the regulatory requirements under the personal data
                protection laws and its regulations.
            </Typography>

            {/* Section 2 */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                Personal Data Collected and Its Purpose
            </Typography>
            <Typography sx={{ mb: 4, fontSize: "20px", }}>
                The GCF collects only necessary personal data to manage any inquiries,
                suggestions, complaints, or to respond to surveys, registration forms,
                or others.
            </Typography>

            {/* Section 3 */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                Methods of Collecting Personal Data
            </Typography>
            <Typography sx={{ mb: 1, fontSize: "20px",  }}>
                Personal data is collected and obtained both directly and indirectly
                through different methods:
            </Typography>
            <ul style={{ fontSize: "20px", }}>
                <li>Direct: Data provided by the data subject to the site.</li>
                <li>Indirect: Data from cookies collected when visiting the GCF’s website.</li>
            </ul>

            {/* Section 4 */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mt: 4, mb: 2, }}>
                Data Sharing / Data Exchange
            </Typography>
            <Typography sx={{ mb: 4 , fontSize: "20px", }}>
                The GCF is committed to maintaining the privacy of personal data and not
                disclosing it following the data sharing controls approved by regulatory
                bodies. GCF complies with the provisions of data confidentiality and
                non-disclosure as per the personal data protection law and its
                regulations.
            </Typography>

            {/* Section 5 */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                Storing and Destroying Personal Data
            </Typography>
            <Typography sx={{ mb: 4, fontSize: "20px",  }}>
                Personal data is securely stored within the Kingdom of Saudi Arabia’s
                geographical boundaries to ensure the preservation of the nation’s
                digital sovereignty over this data. The GCF adheres to the highest
                standards and practices to ensure the security and protection of data.
                It also adheres to national regulations related to destroying personal
                data and disposing of it once the purpose of its collection is fulfilled
                or archiving it securely.
            </Typography>

            {/* Section 6 */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                Data Subject Rights
            </Typography>
            <Typography sx={{ mb: 4, fontSize: "20px",  }}>
                Under the personal data protection law (Royal Decree No. (M/19) of
                9/2/1443H, amended by Royal Decree No. (M/148) of 05/09/1444H), users
                have the following rights:
            </Typography>
            <ul style={{ fontSize: "20px", }}>
                <li>The right to be informed.</li>
                <li>The right to access personal data and request a copy.</li>
                <li>The right to rectify personal data.</li>
                <li>The right to destroy personal data under certain circumstances.</li>
                <li>The right to withdraw consent to process personal data.</li>
            </ul>
            <Typography sx={{ mt: 2, fontSize: "20px",  }}>
                Users may exercise their rights by contacting:
                <br />
                <strong>Email:</strong> info@nca.gov.sa
            </Typography>

            {/* Section 7 */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mt: 4, mb: 2, }}>
                Privacy Policy Updates
            </Typography>
            <Typography sx={{ mb: 4 , fontSize: "20px", }}>
                The GCF reserves the right to add or change any policy provisions as
                necessary. The Arabic language is the official language used in the
                application of terms and conditions, and it shall prevail in the event
                of a discrepancy between the Arabic and English texts.
            </Typography>
        </Box>
    );
}

export default PrivacyPolicy;
